import { render, staticRenderFns } from "./population.vue?vue&type=template&id=161fd9b0&scoped=true&"
import script from "./population.vue?vue&type=script&lang=js&"
export * from "./population.vue?vue&type=script&lang=js&"
import style0 from "./population.vue?vue&type=style&index=0&id=161fd9b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161fd9b0",
  null
  
)

export default component.exports